import React from 'react';
import SphereNetwork from '../components/SphereNetwork';

const Home: React.FC = () => {
  return (
    <div className="relative w-full h-[calc(100vh-4rem)]">
      <SphereNetwork />
    </div>
  );
};

export default Home;
